'use client';

import { CheckableElementProps } from '@/interfaces/basicForm';
import { checkedValue } from '@/utils/helper';
import { useEffect, useState } from 'react';

export const BasicCheckbox = ({ name, value, label, className = '', selectedValues, onChange }: CheckableElementProps) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(checkedValue(selectedValues, value));
  }, [selectedValues, value]);

  return (
    <label className={`checkbox cursor-pointer text-lg ${checked ? 'checked' : ''} ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        className={`form-field cursor-pointer`}
        {...{ name, value }}
        onChange={(e) => {
          setChecked(e.target.checked);
          onChange?.();
        }}
      />
      {label}
    </label>
  );
};
